<template>
  <div
    class="popup-layer-wrapper"
    :style="{
      zIndex: zIndex,
    }"
  >
    <van-popup
      :value="value"
      @click-overlay="throttledOnClose"
      class="order-filter-popup c:col-between-stretch"
      position="top"
    >
      <div class="filter-groups">
        <OrderFilterGroup
          v-if="isMultipleSalers"
          v-model="salerChecked"
          label="销售顾问"
          :options="salerOptions"
        />
        <OrderFilterGroup
          v-model="orderTypeChecked"
          label="订单类型"
          :options="orderTypeOptions"
        />
        <OrderFilterGroup
          v-model="DeliveryMethodChecked"
          label="提货方式"
          :options="DeliveryMethodOptions"
        />
        <OrderFilterGroup
          v-model="orderStatusChecked"
          label="订单状态"
          :options="orderStatusOptions"
        />
        <OrderFilterGroup
          v-model="payStatusChecked"
          label="支付状态"
          :options="payStatusOptions"
        />
        <OrderFilterGroup
          v-model="refundStatusChecked"
          label="是否退款"
          :options="refundStatusOptions"
        />
        <OrderFilterGroup
          v-model="timeRangeChecked"
          label="下单时间"
          :options="timeRangeOptions"
          @itemclick="onTimeRangeClick"
        >
          <div class="time-range-select c:row-center">
            <div
              class="time-select start-time c:row-center"
              :class="{ active: startTime.active }"
              @click="throttledOnStartTimeClick"
            >
              {{ startTime.text }}
            </div>
            <div class="time-range-joint"></div>
            <div
              class="time-select end-timer c:row-center"
              :class="{ active: endTime.active }"
              @click="throttledOnEndTimeClick"
            >
              {{ endTime.text }}
            </div>
          </div>
        </OrderFilterGroup>
      </div>
      <div class="filter-buttons c:row-between-center">
        <CButton large @click="reset">重置</CButton>
        <CButton large @click="confirm" primary>确定</CButton>
      </div>
    </van-popup>
    <CDatePicker
      :title="datePicker.title"
      :active="datePicker.active"
      :init-value="datePicker.value"
      :min-date="datePicker.minDate"
      :max-date="datePicker.maxDate"
      @confirm="onPickDate"
      @cancel="onCancelPickDate"
    ></CDatePicker>
  </div>
</template>

<script>
import { getEmployeeList, getEnums } from "@/api";
import CDatePicker from "../common/CDatePicker.vue";
import CButton from "../common/CButton.vue";
import OrderFilterGroup from "./OrderFilterGroup.vue";
import { mapGetters } from "vuex";
import { throttle } from "@/utils";

export default {
  name: "OrderFilterPopop",
  components: { OrderFilterGroup, CDatePicker, CButton },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 900,
    },
    isMultipleSalers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      salerOptions: [],
      salerChecked: [],

      orderTypeOptions: [],
      DeliveryMethodOptions: [],
      orderStatusOptions: [],
      payStatusOptions: [],
      refundStatusOptions: [
        {
          label: "有退款",
          value: 1,
        },
        {
          label: "无退款",
          value: 0,
        },
      ],
      orderTypeChecked: [],
      DeliveryMethodChecked: [],
      orderStatusChecked: [],
      payStatusChecked: [],
      refundStatusChecked: [],

      //
      // orderTypeChecked: [],
      // orderStatusChecked: [],

      timeRangeOptions: [
        {
          label: "近1个月",
          value: 1,
        },
        {
          label: "近3个月",
          value: 3,
        },
        {
          label: "近6个月",
          value: 6,
        },
      ],
      timeRangeChecked: undefined,
      lastTimeRangeChecked: undefined,
      from: undefined,
      to: undefined,
      datePicker: {
        active: false,
        title: "",
        value: undefined,
        minDate: undefined,
        maxDate: undefined,
      },
    };
  },
  computed: {
    ...mapGetters(["currentStore"]),
    startTime() {
      if (this.from) {
        return {
          active: true,
          text: this.from.format("YYYY年MM月DD日"),
        };
      }
      return {
        active: false,
        text: "起始时间",
      };
    },
    endTime() {
      if (this.to) {
        return {
          active: true,
          text: this.to.format("YYYY年MM月DD日"),
        };
      }
      return {
        active: false,
        text: "终止时间",
      };
    },
  },
  created() {
    this.throttledOnClose = throttle(this.close, 500);
    this.throttledOnStartTimeClick = throttle(this.pickStartTime, 500);
    this.throttledOnEndTimeClick = throttle(this.pickEndTime, 500);

    this.getEnums();
    if (this.isMultipleSalers) {
      this.getSalers();
    }
  },
  methods: {
    async getEnums() {
      try {
        const map = {
          OrderTypeEnum: "orderTypeOptions",
          DeliveryMethodEnum: "DeliveryMethodOptions",
          OrderStatusEnum: "orderStatusOptions",
          PayStatusEnum: "payStatusOptions",
          // OrderRefundStatusEnum: "refundStatusOptions",
        };
        const dict = {
          // 订单: "远程销售单",
          物流发货: "邮寄",
          客户自提: "自提",
          // 待转发: "待分享",
          // 待付款: "待支付",
          // 已过期: "已取消",
          // 未退款: "无退款",
        };
        const res = await getEnums();
        console.log("res", res);
        res.forEach((enumItem) => {
          if (map[enumItem.enumName]) {
            this[map[enumItem.enumName]] = enumItem.items
              .filter((item) => {
                return item.code > -1;
              })
              .map((item) => ({
                label: dict[item.desc] || item.desc,
                value: item.code,
              }));
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    },
    async getSalers() {
      try {
        const res = await getEmployeeList({
          storeId: this.currentStore.storeId,
        });
        console.log("getSalers success", res);
        this.salerOptions = res.map((itemm) => {
          return {
            value: itemm.cawwId,
            label: itemm.caName,
          };
        });
        // console.log(this.salerOptions);
      } catch (error) {
        console.log("getSalers error", error);
      }
    },
    pickStartTime() {
      Object.assign(this.datePicker, {
        type: "start",
        active: true,
        title: "请选择起始时间",
        value: this.from?.toDate(),
        minDate: new Date(2021, 0, 1),
        maxDate: this.to ? this.to.toDate() : new Date(),
      });
    },
    pickEndTime() {
      Object.assign(this.datePicker, {
        type: "end",
        active: true,
        title: "请选择结束时间",
        value: this.to?.toDate(),
        minDate: this.from ? this.from.toDate() : new Date(2021, 0, 1),
        maxDate: new Date(),
      });
    },
    onTimeRangeClick(item) {
      if (item.value === this.lastTimeRangeChecked) {
        this.timeRangeChecked = undefined;
        this.lastTimeRangeChecked = undefined;
      } else {
        this.lastTimeRangeChecked = item.value;
        this.from = undefined;
        this.to = undefined;
      }
    },
    onPickDate(date) {
      console.log("onPickDate", date);
      if (this.datePicker.active) {
        if (this.datePicker.type === "start") {
          this.from = date;
        } else if (this.datePicker.type === "end") {
          this.to = date;
        }
        this.timeRangeChecked = undefined;
        this.lastTimeRangeChecked = undefined;
        this.onCancelPickDate();
      }
    },
    onCancelPickDate() {
      Object.assign(this.datePicker, {
        type: "",
        active: false,
        title: "",
        value: undefined,
        minDate: undefined,
        maxDate: undefined,
      });
    },
    reset() {
      console.log("reset");
      Object.assign(this, {
        DeliveryMethodChecked: [],
        salerChecked: [],
        orderTypeChecked: [],
        orderStatusChecked: [],
        payStatusChecked: [],
        refundStatusChecked: [],
        timeRangeChecked: undefined,
        lastTimeRangeChecked: undefined,
        from: undefined,
        to: undefined,
      });

      this.$emit("filter", {
        caWwidList: undefined,
        orderTypeList: undefined,
        statusList: undefined,
        startTime: undefined,
        endTime: undefined,
      });
      this.close();
    },
    confirm() {
      const {
        salerChecked,
        orderTypeChecked: orderTypeList,
        DeliveryMethodChecked: deliveryMethodList,
        orderStatusChecked: statusList,
        payStatusChecked: payStatusList,
        refundStatusChecked: refundStatusList,
        timeRangeChecked,
        from,
        to,
      } = this;

      let startTime = undefined;
      let endTime = undefined;
      const pattern = "YYYY-MM-DDTHH:mm:ss+08:00";
      if (timeRangeChecked) {
        endTime = this.$moment().format(pattern);
        startTime = this.$moment()
          .subtract(timeRangeChecked, "month")
          .startOf("day")
          .format(pattern);
        this.from = undefined;
        this.to = undefined;
      } else if (from && to) {
        startTime = from.startOf("day").format(pattern);
        endTime = to.endOf("day").format(pattern);
      } else {
        this.from = undefined;
        this.to = undefined;
      }

      this.$emit("filter", {
        caWwidList: this.isMultipleSalers ? salerChecked : undefined,
        orderTypeList: orderTypeList.length ? orderTypeList : undefined,
        deliveryMethodList: deliveryMethodList.length
          ? deliveryMethodList
          : undefined,
        statusList: statusList.length ? statusList : undefined,
        payStatusList: payStatusList.length ? payStatusList : undefined,
        refundStatusList: refundStatusList.length
          ? refundStatusList
          : undefined,
        startTime: startTime || undefined,
        endTime: endTime || undefined,
      });
      this.close();
    },
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="less" scoped>
.popup-layer-wrapper {
  position: relative;
}
.order-filter-popup {
  --top: calc(var(--layout-header-height) + var(--filter-bar-height));
  --bottom: 2.5rem;

  width: 100vw;
  height: calc(var(--dynamic-vh) - var(--top) - var(--bottom));
  top: var(--top);
  background-color: #fff;

  opacity: 1;
}
.filter-groups {
  flex: 1;
  width: 100%;
  // height: 0;
  padding: 8/20rem 20/20rem;
  overflow-x: 0;
  overflow-y: auto;

  .time-range-select {
    gap: 20/20rem;

    width: 100%;
    height: 31/20rem;
    margin-top: 10/20rem;

    .time-select {
      flex: 1;

      width: 0;
      height: 100%;
      background-color: #f1f2f4;

      font-weight: 400;
      font-size: 12/20rem;
      line-height: 18/20rem;
      letter-spacing: 0;
      color: #7d7d7d;

      &.active {
        color: #000;
      }
    }
    .time-range-joint {
      width: 19/20rem;
      height: 3/20rem;
      background-color: #d9d9d9;
    }
  }
}
.filter-buttons {
  gap: 12/20rem;

  box-sizing: border-box;
  width: 100%;
  height: 62/20rem;
  padding: 8/20rem 20/20rem;
}
</style>
